var _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _g, _rect, _rect2, _rect3, _g2, _rect4, _rect5, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 380,
    viewBox: "0 0 651 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 581,
    y1: 341.5,
    x2: 56,
    y2: 341.5,
    stroke: "#DADADA"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 581,
    y1: 287.3,
    x2: 56,
    y2: 287.3,
    stroke: "#DADADA"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 581,
    y1: 234.422,
    x2: 56,
    y2: 234.422,
    stroke: "#DADADA"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 581,
    y1: 177.578,
    x2: 56,
    y2: 177.578,
    stroke: "#DADADA"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 581,
    y1: 123.378,
    x2: 56,
    y2: 123.378,
    stroke: "#DADADA"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 581,
    y1: 70.5,
    x2: 56,
    y2: 70.4999,
    stroke: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 322L183.5 239.5L234 291L288.5 239.5L340 277.267L393 188L437.5 254L580.821 90.2984",
    stroke: "#1674A9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 289.5L126 211.5L185 289.5L291 127.5L346 183.5L428.5 100.5L460.5 156.5L566.5 38.5",
    stroke: "#F3A77B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 109,
    width: 90.6635,
    height: 54.7653,
    rx: 4.21123,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.351,
    y: 109.351,
    width: 89.9616,
    height: 54.0634,
    rx: 3.86029,
    stroke: "#DFDFDF",
    strokeWidth: 0.701871
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 187.935,
    y: 119.241,
    width: 22.3688,
    height: 8.14396,
    rx: 4.07198,
    fill: "#F3A77B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 185.717,
    y: 136.989,
    width: 52.6198,
    height: 14.5544,
    rx: 7.27721,
    fill: "#F3A77B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 243.935,
    y: 136.989,
    width: 17.9131,
    height: 14.5544,
    rx: 7.27721,
    fill: "#F3A77B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 220,
    width: 90.6635,
    height: 54.7653,
    rx: 4.21123,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.351,
    y: 220.351,
    width: 89.9616,
    height: 54.0634,
    rx: 3.86029,
    stroke: "#DFDFDF",
    strokeWidth: 0.701871
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 330.935,
    y: 230.241,
    width: 22.3688,
    height: 8.14396,
    rx: 4.07198,
    fill: "#1674A9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 328.717,
    y: 247.989,
    width: 52.6198,
    height: 14.5544,
    rx: 7.27721,
    fill: "#1674A9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 386.935,
    y: 247.989,
    width: 17.9131,
    height: 14.5544,
    rx: 7.27721,
    fill: "#1674A9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 174.522,
    y: 106.761,
    width: 99.62,
    height: 63.7218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.23914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23914
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 317.522,
    y: 217.761,
    width: 99.62,
    height: 63.7218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.23914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23914
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharts);
export default __webpack_public_path__ + "static/media/charts.604f1d8948262fb471d1daa70d846cc7.svg";
export { ForwardRef as ReactComponent };